var _excluded = ["title", "component", "children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import hyper from "@macrostrat/hyper";
import styles from "./main.module.styl";
var h = hyper.styled(styles);
export function PanelSubhead(props) {
  var title = props.title,
      _props$component = props.component,
      component = _props$component === void 0 ? "h3" : _props$component,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return h("div.panel-subhead", rest, [h(component, {
    className: "title"
  }, title), children]);
}